import { render, staticRenderFns } from "./LeaveInformation.vue?vue&type=template&id=23f2b0b2&scoped=true"
import script from "./LeaveInformation.vue?vue&type=script&lang=js"
export * from "./LeaveInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f2b0b2",
  null
  
)

export default component.exports